module.exports = __webpack_public_path__ + "img/p20.27686995.svg";